/**
 * @voltxampere/ui — DC motor variant (Sprint 44-7, placeholder)
 *
 * PLACEHOLDER. Brushed DC motor — winding endüktansı + back-EMF +
 * mekanik tork basit modeli. Mevcut `inductor` stamp üzerinden
 * tek armature winding gösterir; back-EMF (ω-dependent voltage
 * source) + rotor mekanik dynamics Sprint 47+ engine extension #4
 * ile aktif olur.
 *
 * Reference: Generic 12 V DC motor — Maxon RE 35 / Pololu 25Dx52L.
 * V_nom = 12 V, I_no-load = 50 mA, I_stall = 5 A, R_arm = 2.4 Ω,
 * L_arm = 1 mH, K_e = 0.0107 V/(rad/s), K_t = 0.0107 N·m/A.
 * Robotic actuator + fan + small pump.
 *
 * Engine zero-diff invariant honored — canonical `inductor` engine
 * type via schemaType (winding endüktansı; back-EMF Sprint 47+'da).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { inductor } from "../inductor.js";
export const motorDc = {
    id: "motor-dc",
    nameTr: "DC Motor 12V (placeholder, winding only)",
    nameEn: "DC Motor 12V (placeholder, winding only)",
    shortcut: "L",
    category: "active",
    viewBox: inductor.viewBox,
    terminals: inductor.terminals,
    defaultLabel: "M",
    defaultValue: "DC-12V",
    schemaType: "inductor",
    defaultParams: { inductance: 1e-3 },
    renderSVG: () => inductor.renderSVG(),
};
//# sourceMappingURL=motor-dc.js.map